import React from "react";
import { Box } from "@mui/material/";
import Routes from "./Routes";
import styles from "./styles";

export default () => {
    return (
        <Box sx={styles.container}>
            <Routes />
        </Box>
    );
};
